import { httpClient } from "./http-client";
const basePath = "/telegram-subscription";

export const telegramSubscriptionAPI = {
  create: async (categoryNames: string[], companyName: string, minSalary: string, 
    location: string, attendanceRequirement: string, searchTerm: string , contractType: string) => 
  {
    const url = basePath + "/create";
    return await httpClient.post(url, {
      SearchSubscription : {
        CategoryNames: categoryNames,
        CompanyName: companyName,
        MinSalary: minSalary,
        Location: location,
        AttendanceRequirement: attendanceRequirement,
        SearchTerm: searchTerm,
        ContractType: contractType
      },
    });
  },
};